import {createMuiTheme} from "@material-ui/core";
import {AcnColorTheme} from "../../assets/css/AcnColorTheme";

export const AppThemes = createMuiTheme({
    palette: {
        primary: {
            main: AcnColorTheme.primary
        },
        secondary: {
            main: AcnColorTheme.secondary
        },
        error: {
            main: AcnColorTheme.danger
        },
        warning: {
            main: AcnColorTheme.warning
        },
        info: {
            main: AcnColorTheme.primary
        },
        success: {
            main: AcnColorTheme.success
        },
        divider: AcnColorTheme.divider,
    },
    typography: {
        fontFamily: 'Prompt-Medium, Helvetica, Roboto, sans-serif',
    }
});

export const MarkdownTheme = {
    h1: {
        props: {
            style: {margin:0}
        },
    },
    h2: {
        props: {
            style: {margin:0}
        },
    },
    h3: {
        props: {
            style: {margin:0}
        },
    },
    h4: {
        props: {
            style: {margin:0}
        },
    },
    h5: {
        props: {
            style: {margin:0}
        },
    },
    h6: {
        props: {
            style: {margin:0}
        },
    },
    // p: {
    //     props: {
    //         style: {margin:0}
    //     },
    // },
    // ul: {
    //     props: {
    //         style: {margin:0}
    //     },
    // },
}